var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tag-no-result" }, [
      _c("img", {
        staticClass: "tag-no-result-img",
        attrs: { src: require("../../common/images/tagNoResult@3x.png") },
      }),
      _vm._v(" "),
      _c("p", { staticClass: "tag-no-result-p1" }, [
        _vm._v("\n    什么都没找到QAQ\n  "),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "tag-no-result-p2" }, [
        _vm._v("\n    换个关键词试试\n  "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }